import React from 'react';
import { mapProps, compose } from 'recompose';

import { getRouteInfo } from '../utils';

import Users from './Users';

export default compose(mapProps(getRouteInfo))(Users);
